var React = require('react');

function NonAvailable (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","fill":"none","key":0}),React.createElement("line",{"x2":"14","transform":"translate(3 10.5)","fill":"none","stroke":"#8691a0","strokeLinecap":"round","strokeWidth":"2","key":1})]);
}

NonAvailable.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = NonAvailable;

NonAvailable.default = NonAvailable;
